import { IDocumentoResponse } from '../entities/IDocumentoResponse'
import { ILoteSolicitadoRepository } from '../repositories/ILoteSolicitadoRepository'

export interface IGetDocumentos {
  execute(tmovLoteConjuntoId: number): Promise<IDocumentoResponse[]>
}

export default class IGetDocumentosImpl implements IGetDocumentos {
  constructor(
    private readonly loteSolicitadoRepository: ILoteSolicitadoRepository,
  ) {}

  public async execute(
    tmovLoteConjuntoId: number,
  ): Promise<IDocumentoResponse[]> {
    return this.loteSolicitadoRepository.getDocumentos(tmovLoteConjuntoId)
  }
}
